import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default {
  path: "/dict",
  redirect: "/dict/stroke",
  name: "Dict",
  component: LAYOUT,
  meta: {
    order: 999,
    roles: ManagerType.ProjectAdmin,
    title: "字典管理",
    icon: "material-symbols:dictionary",
  },
  children: [
    {
      path: "stroke",
      name: "StrokePage",
      component: () => import("../../views/stroke/StrokePage.vue"),
      meta: {
        title: "泳姿管理",
      },
    },
    {
      path: "preset-event",
      name: "PresetEventPage",
      component: () => import("../../views/presetEvent/PresetEventPage.vue"),
      meta: {
        title: "小项字典",
      },
    },
  ],
} as RouteRecordRaw;
